export const Roles = {
    Admin: 'Admin',
    Manager: 'Manager',
    FinanceManager: 'FinanceManager',
};

export default Roles;
